module.exports = __webpack_public_path__ + "static/fun-time/games/page000_game1/audio//13_pink.mp3";